module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2-1",
    attrs: {
      "id": "con"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rack"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253042125_Acknowledgments"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "top3"
  }, [_c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "rint"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253042125_Introduction"
    }
  }, [_vm._v("Introduction / James Ogude")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_3",
    attrs: {
      "id": "rch01"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253042125_Chapter01"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Ubuntu in the Christian Theology and Praxis of Archbishop Desmond Tutu and Its Implications for Global Justice and Human Rights / Aloo Osotsi Mojola")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_3",
    attrs: {
      "id": "rch02"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042125_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Crafting Ideal Conditions: Ubuntu and the Challenges of Modern Society / D. A. Masolo")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_3",
    attrs: {
      "id": "rch03"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042125_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The Art of Personhood: Kinship and Its Social Challenges / Bhekizizwe Peterson")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_3",
    attrs: {
      "id": "rch04"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042125_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The Philosophy of Ubuntu and the Notion of Vital Force / Niels Weidtmann")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_3",
    attrs: {
      "id": "rch05"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042125_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Rethinking Ubuntu / Dirk J. Louw")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_3",
    attrs: {
      "id": "rch06"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042125_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Ubuntu and Oruka’s Humanitarian View of Punishment / Oriare Nyarwath")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_3",
    attrs: {
      "id": "rch07"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042125_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Ubuntu and "), _c('i', [_vm._v("Buen Vivir")]), _vm._v(": A Comparative Approach / Anke Graness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_3",
    attrs: {
      "id": "rch08"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042125_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Ubuntu and Christianity / Augustine Shutte")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_3",
    attrs: {
      "id": "rch09"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042125_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Ubuntu, Reconciliation in Rwanda, and Returning to Personhood through Collective Narrative / Anna-Marie de Beer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_3a",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253042125_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Utu/Ubuntu and Community Restoration: Narratives of Survivors in Kenya’s 2007 Postelection Violence / James Ogude and Unifier Dyer")])])])]), _vm._v(" "), _c('div', {
    staticClass: "top3"
  }, [_c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rind"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042125_Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdf8574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253042125_Contents.vue
// module id = 69
// module chunks = 0